if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

function boldCheck() {
    // check for bold options and verify all options are selected
    const defaultOptions = document.getElementsByClassName(
        "bold_option_dropdown"
    );
    const selectedOptions =
        document.getElementsByClassName("bold_option_total").length > 0
            ? document
                  .getElementsByClassName("bold_option_total")[0]
                  .childNodes[1].value.split(",")
            : null;
    const boldButton = document.querySelector(".bold_clone");
    if (defaultOptions.length != 0) {
        const optionElements = document.querySelectorAll(
            ".bold_option_element select"
        );
        let formComplete = true;
        let optionProps = {};
        optionElements.forEach(function(option) {
            let required =
                option.parentNode.parentNode.children[0].textContent.indexOf(
                    "*"
                ) != -1;
            if (required && !option.value) {
                formComplete = false;
            } else {
                let title = option.name.substring(
                    option.name.indexOf("[") + 1,
                    option.name.indexOf("]")
                );
                optionProps[title] = option.value;
            }
        });
        if (!formComplete) {
            boldButton.click();
            optionProps = {};
            return false;
        } else return optionProps;
    }
}

function buildWishlistItems(optionProps) {
    selectedOptions = document.getElementsByClassName("bold_option_total")[0];
    // set the product to defaults needed for wishlist
    let product = {
        baseId: document.getElementById("product_id").value,
        title: document.getElementById("product_title").value,
        price: document.getElementById("product_price").value,
        qty: document.querySelector(".qtyWrap input").value,
        image: document.getElementById("product_img").value,
        url: document.getElementById("product_url").value,
        swymProps: {
            properties: {},
            boldOptions: [],
            available: document.getElementById("product_available").value,
        },
    };
    // check for potential variants and update product data to selected variant or first variant if none selected
    const selectedVariant = location.search.substring(
        location.search.indexOf("=") + 1
    );
    const variants = document.getElementsByName("product_variants");
    if (variants.length > 0) {
        let index = 0;
        if (selectedVariant != "") {
            for (let i in variants) {
                let vals = variants[i].value.split(",");
                if (vals.includes(selectedVariant)) {
                    index = i;
                    break;
                }
            }
        }
        let vals = variants[index].value.split(",");
        // variant image is last item in shopify's variant formatting
        let image = vals.pop();
        // if variant id exists, it would be the next item, otherwise the next item is the title, which would parse as NaN
        let id = !isNaN(parseInt(vals[vals.length - 1]))
            ? vals.pop()
            : document.getElementById("product_id").value;
        product.id = id;
        if (image != "") {
            product.image =
                "https://cdn.shopify.com/s/files/1/0114/5919/9034/${image}" +
                image;
        }
        // the remaining fields are variant titles (i.e. ['bulk', 'unmilled']), join for display
        product.variantTitle =
            vals[0] != "Default Title" ? vals.join(", ") : null;
    }
    let wishListItems = [];
    if (optionProps) {
        Object.keys(optionProps).forEach(function(key) {
            product.swymProps.properties[key] = optionProps[key];
        });
    }
    //if bold options exist, update product data accordingly
    if (selectedOptions) {
        product.swymProps.properties._boldBuilderId = document.querySelector(
            "input[name='properties[_boldBuilderId]']"
        ).value;
        product.swymProps.properties._boldVariantNames = document.querySelector(
            "input[name='properties[_boldVariantNames]']"
        ).value;
        product.swymProps.properties._boldVariantIds = document.querySelector(
            "input[name='properties[_boldVariantIds]']"
        ).value;
        product.swymProps.properties._boldProductIds = document.querySelector(
            "input[name='properties[_boldProductIds]']"
        ).value;
        product.swymProps.properties._boldVariantPrices = document.querySelector(
            "input[name='properties[_boldVariantPrices]']"
        ).value;
        const boldVariantIds = product.swymProps.properties._boldVariantIds.split(
            ","
        );
        const boldVariantNames = product.swymProps.properties._boldVariantNames.split(
            ","
        );
        const boldVariantPrices = product.swymProps.properties._boldVariantPrices.split(
            ","
        );
        const boldVariantQtys = document
            .querySelector("input[name='properties[_boldVariantQtys]']")
            .value.split(",");
        // create cart/wishlist items for selected options
        for (let i = 0; i < boldVariantNames.length; i++) {
            let variantProduct = {
                title: boldVariantNames[i],
                id: boldVariantIds[i],
                properties: {
                    _boldBuilderId: product.swymProps.properties._boldBuilderId,
                },
            };
            if (boldVariantQtys[0] !== "") {
                variantProduct.qty = boldVariantQtys[i];
            }
            wishListItems.push(variantProduct);
        }
    }
    product.swymProps.boldOptions = wishListItems;
    wishListAdd(product);
}

function checkWishList(id) {
    if (window._swat) {
        window._swat.fetch(function(r) {
            for (let i in r) {
                if (r[i].empi == id) {
                    document.getElementById("wishlist-add").style.display =
                        "none";
                    document.getElementById("wishlist-remove").style.display =
                        "inline-block";
                    break ;
                }
            }
        });
    }
}

function handleATC(e) {

    console.log('EVENT', e)

    var article = $(e.target).closest("article");

    console.log('ARTICLE', article)

    var data = $(article).attr("data-cart-items");

    console.log('DATA', data)

    var mainID = $(article).attr("data-id");

    console.log('MAIN ID', mainID)

    var mainBaseID = $(article).attr("data-base-id");

    console.log('MAIN BASE ID', mainBaseID)
    var mainQty = $(article).attr("data-qty");

    console.log('MAIN QTY', mainQty)

    var item = JSON.parse(data);

    console.log('ITEM', item)

    var inputQty = parseInt(
        $(article)
            .find("input")
            .val()
    );
    
    Shopify.queue = [];
    var mainProduct = {
        id: parseInt(mainID),
        properties: item.properties,
        quantity: parseInt(parseInt(mainQty) != inputQty ? inputQty : mainQty),
    };
    Shopify.queue.push(mainProduct);
    // item.boldOptions.forEach(function(option) {
    //     var optionQty = null;
    //     if (mainQty != inputQty) {
    //         if (option.qty) {
    //             optionQty = parseInt(option.qty) / parseInt(mainQty) / inputQty;
    //         }
    //     }
    //     var boldProduct = {
    //         id: parseInt(option.id),
    //         properties: option.properties,
    //         quantity: optionQty || mainQty,
    //     };
    //     Shopify.queue.push(boldProduct);
    // });
    Shopify.moveAlong = function() {
        if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: request,
                success: function(data) {
                    if (data != null && data.success) {
                        Shopify.moveAlong();
                    }
                },
            });
        }
    };
    Shopify.moveAlong();

    $(e.target)
        .closest("article")
        .remove();
    wishListRemove(mainBaseID);
    var currentCartCount = parseInt(
        document
            .getElementsByClassName("site-header-cart--count")[0]
            .getAttribute("data-header-cart-count")
    );
    var cartCount = isNaN(currentCartCount) ? 0 : currentCartCount;
    var cartIcon = document.getElementsByClassName(
        "site-header-cart--count"
    )[0];
    cartIcon.setAttribute(
        "data-header-cart-count",
        (cartCount + inputQty).toString()
    );
    cartIcon.classList.add("visible");
}

function handleDelete(e) {
    wishListRemove(parseFloat(e.target.getAttribute("data-id")));
    $(e.target)
        .closest("article")
        .remove();
}

function handleQtyChange(e) {
    var article = $(e.target).closest("article");
    var inputQty = parseInt(
        $(article)
            .find("input")
            .val()
    );
    if (e.target.classList.contains("plus")) {
        $(article)
            .find("input")
            .val((inputQty + 1).toString());
    } else if (e.target.classList.contains("minus") && inputQty > 1) {
        $(article)
            .find("input")
            .val((inputQty - 1).toString());
    }
}

function swymCallbackFn(swat) {
	function renderWishList() {
		if (swat) {
			swat.fetch(function (r) {
				var wishlistCartElements = document.getElementById("wishlist--cartItems");
				let itemCounter = 0;
				let pageCounter = 1;
				if (r.length > 0) {
					for (let i in r) {

                        console.log('R', r[i])

						if (r[i].bt || r[i].cprops.string) {
							itemCounter++;
							var decompStr = null;
							var listItem = null;
							if (r[i].cprops) {
								decompStr = LZString.decompressFromUTF16(
									r[i].cprops.string
								);
							}
							if (decompStr) {
								listItem = JSON.parse(decompStr);
							} else if (r[i].bt) {
                                try {
                                  listItem = JSON.parse(r[i].bt);  
                                } catch (error) {
                                  continue;
                                }
							}
							var cost = r[i].pr * 100;
							var fragment = document.createDocumentFragment();
							var article = document.createElement("article");
							article.setAttribute(
								"class",
								"cart-item wishlist--cart-item visibleItem wishlist--page" +
								pageCounter
							);
							article.setAttribute(
								"data-cart-items",
								JSON.stringify(r[i]) || decompStr
							);
							article.setAttribute("data-id", r[i].epi);
							article.setAttribute("data-qty", r[i].cprops.qty);
							article.setAttribute("data-base-id", r[i].empi);
							if (pageCounter > 1) {
								article.style.display = "none";
							}
							var figure = document.createElement("figure");
							figure.setAttribute(
								"class",
								"cart-item--image-wrapper wishlist--cart-item--image"
							);
							var link = document.createElement("a");
							link.setAttribute(
								"href",
								r[i].epi !== r[i].empi
									? r[i].du + "?variant=$" + r[i].epi
									: r[i].du
							);
							var image = document.createElement("img");
							image.setAttribute("src", r[i].iu);
							image.setAttribute("alt", r[i].dt);
							link.appendChild(image);
							figure.appendChild(link);
							article.appendChild(figure);
							var cartItemInner = document.createElement("div");
							cartItemInner.setAttribute(
								"class",
								"wishlist--cart-item--inner"
							);
							var cartItemContent = document.createElement("div");
							cartItemContent.setAttribute(
								"class",
								"cart-item--content"
							);
							var cartItemTitle = document.createElement("h2");
							cartItemTitle.setAttribute(
								"class",
								"cart-item--content-title"
							);
							var cartItemTitleLink = document.createElement("a");
							cartItemTitleLink.setAttribute(
								"href",
								r[i].epi !== r[i].empi
									? r[i].du + "?variant=" + r[i].epi
									: r[i].du
							);
							cartItemTitleLink.innerHTML = r[i].dt;
							cartItemTitle.appendChild(cartItemTitleLink);
							cartItemContent.appendChild(cartItemTitle);
							if (listItem.boldOptions.length > 0) {
								for (
									let j = 0;
									j < listItem.boldOptions.length;
									j++
								) {
									var itemProp = document.createElement("div");
									itemProp.setAttribute("class", "itemProp");
									var propertyTitle = document.createElement("p");
									propertyTitle.innerHTML =
										Object.keys(listItem.properties)[j] + ":";
									var propertyDescription = document.createElement(
										"span"
									);
									propertyDescription.innerHTML =
										listItem.properties[
											Object.keys(listItem.properties)[j]
											];
									propertyTitle.appendChild(propertyDescription);
									itemProp.appendChild(propertyTitle);
									cartItemContent.appendChild(itemProp);
									boldOptionPrices = listItem.properties._boldVariantPrices.split(
										","
									);
									cost += parseFloat(boldOptionPrices[j]);
								}
							}
							cartItemInner.appendChild(cartItemContent);
							var cartItemInfo = document.createElement("div");
							cartItemInfo.setAttribute("class", "cart-item--info");
							var cartItemQty = document.createElement("div");
							cartItemQty.setAttribute(
								"class",
								"cart-item--quantity form-fields--quantity"
							);
							var qtyAdjust = document.createElement("div");
							qtyAdjust.setAttribute("class", "qtyAdjust");
							var qtyWrap = document.createElement("div");
							qtyWrap.setAttribute("class", "qtyWrap");
							var label = document.createElement("label");
							label.innerHTML = "Quantity";
							qtyWrap.appendChild(label);
							var input = document.createElement("input");
							input.setAttribute("value", r[i].cprops.qty);
							qtyWrap.appendChild(input);
							qtyAdjust.appendChild(qtyWrap);
							var plus = document.createElement("span");
							plus.setAttribute(
								"class",
								"adjust plus bold-quantity-update"
							);
							plus.innerHTML = "+";
							plus.addEventListener("click", handleQtyChange);
							qtyAdjust.appendChild(plus);
							var minus = document.createElement("span");
							minus.setAttribute(
								"class",
								"adjust minus bold-quantity-update"
							);
							minus.innerHTML = "-";
							minus.addEventListener("click", handleQtyChange);
							qtyAdjust.appendChild(minus);
							cartItemQty.appendChild(qtyAdjust);
							cartItemInfo.appendChild(cartItemQty);
							var cartItemDelete = document.createElement("div");
							cartItemDelete.setAttribute(
								"class",
								"wishlist--cart-item--remove"
							);
							var trashCan = document.createElement("img");
							trashCan.setAttribute(
								"src",
								"//cdn.shopify.com/s/files/1/0114/5919/9034/t/46/assets/delete.png?2516321533239273066"
							);
							trashCan.setAttribute("data-id", r[i].empi);
							trashCan.addEventListener("click", handleDelete);
							cartItemDelete.appendChild(trashCan);
							cartItemInfo.appendChild(cartItemDelete);
							var cartItemTotal = document.createElement("div");
							cartItemTotal.setAttribute("class", "cart-item--total");
							var totalWrap = document.createElement("span");
							totalWrap.setAttribute("class", "totalWrap");
							var money = document.createElement("span");
							money.setAttribute("class", "money");
							money.innerHTML = "$" + (cost / 100) * r[i].cprops.qty;
							totalWrap.appendChild(money);
							var contentPrice = document.createElement("div");
							contentPrice.setAttribute(
								"class",
								"cart-item--content-price"
							);
							contentPrice.innerHTML =
								"(" + r[i].cprops.qty + " x $" + cost / 100 + ")";
							totalWrap.appendChild(contentPrice);
							cartItemTotal.appendChild(totalWrap);
							cartItemInfo.appendChild(cartItemTotal);
							cartItemInner.appendChild(cartItemInfo);
							article.appendChild(cartItemInner);
							var cartButton = document.createElement("button");
							cartButton.setAttribute(
								"class",
								"wishlist--atc-button"
							);
							if (listItem.available === "false") {
								cartButton.classList.add("disabled");
							} else {
								cartButton.addEventListener("click", handleATC);
							}
							var buttonText = document.createElement("span");
							buttonText.setAttribute("class", "atc-button--text");
							buttonText.innerHTML =
								listItem.available === "false"
									? "OUT OF STOCK"
									: "ADD TO CART";
							cartButton.appendChild(buttonText);
							var icon = document.createElement("img");
							icon.setAttribute(
								"src",
								"//cdn.shopify.com/s/files/1/0114/5919/9034/t/46/assets/cart-icon.svg"
							);
							cartButton.appendChild(icon);
							article.appendChild(cartButton);
							fragment.appendChild(article);
                            if(wishlistCartElements){
                              wishlistCartElements.appendChild(fragment);
                            }else{
                              console.log("No Wishlist Cart Elements", "Selector : wishlist--cartItems");
                            }
							if (itemCounter == 10) {
								pageCounter++;
								itemCounter = 0;
							}
						}
					}
				} else {
					var fragment = document.createDocumentFragment();
					var article = document.createElement("article");
					article.setAttribute("class", "wishlist--empty");
					var header = document.createElement("p");
					header.setAttribute("class", "wishlist--empty-header");
					header.innerHTML =
						"Looks like you haven't added anything to your wishlist yet.";
					var center = document.createElement("p");
					center.setAttribute("class", "wishlist--empty-center");
					center.innerHTML =
						"Add items to your wishlist to revisit them later. When you're ready to buy, add products from your wishlist directly to your cart.";
					var button = document.createElement("a");
					button.setAttribute("class", "wishlist--empty-button");
					button.setAttribute("href", "/");
					button.innerHTML = "SHOP NOW >";
					$(button).click(function () {
						dataLayer.push({
							event: "emptyWishlistClick",
						});
					});
					article.appendChild(header);
					article.appendChild(center);
					article.appendChild(button);
					fragment.appendChild(article);
                    if(wishlistCartElements){
                     wishlistCartElements.appendChild(fragment); 
                    }else{
                      console.log("No Wishlist Cart Elements", "Selector : wishlist--cartItems");
                    }
				}
				$(".wishlist--loader").hide();
				if (pageCounter > 1) {
					buildPagination(pageCounter);
				}
			});
		}
	}

	setTimeout(function () {
		if (renderWishList) {
			renderWishList()
		}
		;
	}, 1000)
}

function swymAdd() {
    const optionProps = boldCheck();
    if (optionProps !== false) {
        buildWishlistItems(optionProps);
    }
}

function wishListAdd(item) {
    let du = "https://"+window.location.host + item.url
    //console.log(item, "Product Swym", du);

    let swymItem = {
        empi: item.baseId,
        epi: item.id,
        du : du,
        pr: parseFloat(item.price) / 100,
        iu: document.getElementById("product_img").value,
        cprops: {
            string: LZString.compressToUTF16(JSON.stringify(item.swymProps)),
            qty: document.querySelector("input[name=quantity]").value,
        },
    };
    if (window._swat) {
        window._swat.addToWishList(swymItem, function(r) {
            document.getElementById("wishlist-add").style.display = "none";
            document.getElementById("wishlist-remove").style.display =
                "inline-block";
        });
    }
}

function wishListRemove(id) {
    if (window._swat) {
        window._swat.fetch(function(r) {
            for (let i in r) {
                if (r[i].empi == id) {
                   window._swat.removeFromWishList(r[i], function(removedProduct){
                     if (document.getElementById("wishlist-remove")) {
                        document.getElementById(
                            "wishlist-remove"
                        ).style.display = "none";
                        document.getElementById("wishlist-add").style.display =
                            "inline-block";
                    }
                     console.log("Product Removed", removedProduct);
                   })                    
                    break;
                }
            }
        });
    }
}

function buildPagination(count) {
    for (let i = 1; i <= count; i++) {
        var pagButton = $("<div></div>")
            .text(i)
            .addClass(
                i == 1
                    ? "wishlist--pagination-button selected"
                    : "wishlist--pagination-button"
            );
        $(pagButton).click(function() {
            $(".wishlist--cart-item").each(function() {
                $(this).hide();
            });
            $(".wishlist--page" + i).each(function() {
                $(this).show();
            });
            $(".wishlist--pagination-button").each(function() {
                $(this).removeClass("selected");
            });
            $(this).addClass("selected");
        });
        $("#wishlist--pagination").append(pagButton);
        $("#wishlist--pagination").css("display", "flex");
    }
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);